import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}`);
      const defaultTo = user.role === "admin"
        ? "/admin"
        : (user.role === "individual" || user.role === "business" ? "/dashboard" : "/");
      const to = location.state?.from || defaultTo;
      navigate(to);
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail) || "Sign-in failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#5F6C60] text-center">Welcome back</div>
      <h1 className="font-serif-display text-4xl tracking-tight text-center mt-2">Sign in to Massage Savings</h1>

      <form onSubmit={submit} className="mt-10 bg-white p-8 rounded-2xl border border-[#E8E2D6] space-y-5">
        <div>
          <Label htmlFor="email" className="text-xs font-bold uppercase tracking-[0.15em]">Email</Label>
          <Input data-testid="login-email" id="email" type="email" required value={email} onChange={e=>setEmail(e.target.value)} className="mt-2 bg-[#F9F7F3] border-[#E8E2D6] rounded-xl h-12" />
        </div>
        <div>
          <Label htmlFor="password" className="text-xs font-bold uppercase tracking-[0.15em]">Password</Label>
          <Input data-testid="login-password" id="password" type="password" required value={password} onChange={e=>setPassword(e.target.value)} className="mt-2 bg-[#F9F7F3] border-[#E8E2D6] rounded-xl h-12" />
        </div>
        <Button data-testid="login-submit" disabled={loading} type="submit" className="w-full h-12 rounded-full bg-[#D97757] hover:bg-[#C26243] text-white">{loading ? "Signing in…" : "Sign in"}</Button>
        <div className="flex justify-between items-center text-sm text-[#5F6C60]">
          <Link data-testid="forgot-password-link" to="/forgot-password" className="text-[#D97757] hover:underline">Forgot password?</Link>
          <span>No account? <Link to="/register" className="text-[#D97757] hover:underline">Create one</Link></span>
        </div>
      </form>
    </div>
  );
}
